import { Button, Checkbox, Form, Input, Link, Message, Tabs } from '@arco-design/web-react'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { loginApi } from '@/services/login'
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { SecureStringGenerator } from "@/utils";
function UserLogin() {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [checkdata, setcheckdata] = useState(false);

    const validatePhoneNumber = (value, callback) => {
        const regex = /^1(3|4|5|6|7|8|9)\d{9}$/;
        if (!value) {
            callback(<div>请输入正确的用户名</div>);
        } else {
            callback();
        }
    };
    function validatePassword(value, callback) {
        if (!value) {
            callback(<div>密码不能为空</div>);
        } else if (!/^.{6,}$/.test(value)) {
            callback(
                <div>请输入6-12个字符，支持数字、大小写字母和符号至少包含一种</div>
            );
        } else {
            callback();
        }
    }
    useEffect(() => {
        if (Cookies.get("user_aes_key")) {
            const encryptedData = Cookies.get("user_aes_key");
            try {
                // 解密数据
                const bytes = CryptoJS.AES.decrypt(
                    encryptedData,
                    SecureStringGenerator.generate(16)
                );

                // 将解密后的字节转换为 UTF-8 字符串
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);

                // 检查解密后的数据是否是有效的 UTF-8 字符串
                if (decrypted) {
                    try {
                        // 解析解密后的 JSON 字符串
                        const data = JSON.parse(decrypted);
                        const { phone_number, password } = data;

                        // 设置表单字段值
                        form.setFieldValue("phone_number", phone_number);
                        form.setFieldValue("password", password);

                        // 设置 checkdata 为 true
                        setcheckdata(true);
                    } catch (error) {
                        console.error("解析解密后的数据时出错:", error);
                    }
                } else {
                    console.error("解密后的数据不是有效的 UTF-8 字符串。");
                }
            } catch (error) {
                console.error("解密数据时出错:", error);
            }
        }
    }, []);
    return (
        <Form form={form} wrapperCol={{ span: 24 }} style={{ width: 386 }} onSubmit={() => {
            form.validate().then(formData => {
                setLoading(true)
                loginApi(formData).then(res => {
                    localStorage.setItem('Token', res.data.token)
                    if (checkdata) {
                        const data = {
                            phone_number: formData.phone_number,
                            password: formData.password,
                        };
                        Cookies.set(
                            "user_aes_key",
                            CryptoJS.AES.encrypt(
                                JSON.stringify(data),
                                SecureStringGenerator.generate(16)
                            ).toString(),
                            {
                                expires: 7,
                            }
                        );
                    }
                    else {
                        Cookies.remove("user_aes_key");

                    }
                    navigate('/matrix')
                }).catch(e => {
                    // Message.error(e)
                }).finally(() => {
                    setLoading(false)
                })
            })
        }}>
            <Form.Item
                field="phone_number"
                rules={[
                    { validator: validatePhoneNumber, validateTrigger: "onBlur" },
                ]}>
                <Input className="login-input" autoComplete="username"
                    placeholder='请输入账号'></Input>
            </Form.Item>
            <Form.Item field="password"
                rules={[{ validator: validatePassword, validateTrigger: ["onBlur"] }]}
            >
                <Input.Password className="login-input" placeholder='请输入密码'></Input.Password>
            </Form.Item>
            <div id="login-actions">
                <Checkbox
                    checked={checkdata}
                    onChange={() => {
                        setcheckdata(!checkdata);
                    }}
                >
                    记住密码
                </Checkbox>

            </div>
            <Form.Item>
                <Button loading={loading} className="login-button" type="primary" size="large" onClick={() => form.submit()}>登录</Button>
            </Form.Item>
        </Form>
    )
}

export default UserLogin